import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"

type Jid = string

export type ChatSettings = {
  chatJid: string
  muted?: boolean
  archived?: boolean
}

type ChatsSettingsState = Record<Jid, ChatSettings>

type BatchAddChatsSettingsAction = { settings: ChatSettings[] }
type AddChatSettingsAction = { chatSettings: ChatSettings }
type RemoveChatSettingsAction = { chatJid: Jid }
const initialState: ChatsSettingsState = {}

const chatsSettingsSlice = createSlice({
  name: "chatsSettings",
  initialState,
  reducers: {
    batchAddChatsSettings: (
      state,
      action: PayloadAction<BatchAddChatsSettingsAction>,
    ) => {
      action.payload.settings.forEach((chatSettings) => {
        state[chatSettings.chatJid] = chatSettings
      })
    },
    addChatSettings: (state, action: PayloadAction<AddChatSettingsAction>) => {
      state[action.payload.chatSettings.chatJid] = action.payload.chatSettings
    },
    removeChatSettings: (
      state,
      action: PayloadAction<RemoveChatSettingsAction>,
    ) => {
      delete state[action.payload.chatJid]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { batchAddChatsSettings, addChatSettings, removeChatSettings } =
  chatsSettingsSlice.actions

export default chatsSettingsSlice.reducer
